export enum ValidationConstants {
  tool = "appValidation",
  message = "sendTelemetryEvent",
  onValidationCompletion = "onValidationCompletion",
  onLoad = "onLoaded",
  onHelpLinkClick = "onHelpLinkClick",
}

export interface IValidationTelemetryProperties {
  tool: string
  event: string
  telemetryData?: {
    [key: string]: any;
  }
}

export interface IValidationWarning {
  content: string,
  filePath: string,
  helpUrl: string,
  id: string,
  shortCodeNumber: number,
  title: string,
  validationCategory: string
}

export type IValidatoinError = IValidationWarning
